import {
  faFile,
  faHouse,
  faEnvelope,
  faArrowAltCircleLeft,
  faChartArea,
  faCompass,
  faTableCells,
  faArchive,
  faMap,
  faChartColumn,
  faMoneyBill,
  faChartBar,
  faChartSimple,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SubMenu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { Page } from "@thoughtspot/visual-embed-sdk";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRules } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { ForecastVariance } from "../pages/demos/grate/ForecastVariance";
import { MBABenchmark } from "../pages/demos/grate/MBABenchmark";
import { PublicPlayersBenchmark } from "../pages/demos/grate/PublicPlayersBenchmark";
import { WaterfallPlots } from "../pages/demos/grate/WaterfallPlots";
import { SignOut } from "../pages/sign-out/SignOut";
import { Redirect } from "../Redirect";
import {
  SubdomainOrgIdObject,
  subMenuDefaultProps,
} from "./FunctionsAndInterfaces";

const orgId: number = 818396742;
const subDomain: string = "gr";
const nameOfProduct: string = "GR";
const secureRouteGroups: string[] = ["GRate"];

export const gRateObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
  externalInfo: { subdomain: "g-rate", productURL: "grate" },
};

const sidebarMenu = () => {
  return (
    <>
      <SubMenu
        {...subMenuDefaultProps}
        title={"GRate"}
        icon={<FontAwesomeIcon className="me-2" icon={faFile} />}
      >
        <MenuItem>
          <Link to={`/${subDomain}`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faHouse} />
              Home
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/contactus`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faEnvelope} />
              Contact Us
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/signout`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
              Log Out
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Analyses"}
        icon={<FontAwesomeIcon className="me-2" icon={faChartArea} />}
      >
        <MenuItem>
          <Link to={`/${subDomain}/forecast-variance`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faCompass} />
              Forecast Variance
            </div>
          </Link>
        </MenuItem>
        <SubMenu
          {...subMenuDefaultProps}
          title={"MBA Benchmark"}
          icon={<FontAwesomeIcon className="me-2" icon={faTableCells} />}
        >
          <MenuItem>
            <Link to={`/${subDomain}/mba-benchmark-q3-2024`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faArchive} />
                Q3 2024
              </div>
            </Link>
          </MenuItem>
        </SubMenu>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/de4276a9-1c75-4d2e-9921-e4c7cce70740&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faMap} />
              Performance Summary Trends (Last 30 Days)
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/2c8c538a-cb4a-4ff2-9635-91989faac562&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faChartColumn} />
              Pipeline Analytics
            </div>
          </Link>
        </MenuItem>
        <SubMenu
          {...subMenuDefaultProps}
          title={"Public Players Benchmark"}
          icon={<FontAwesomeIcon className="me-2" icon={faMoneyBill} />}
        >
          <MenuItem>
            <Link to={`/${subDomain}/public-players-benchmark-q3-24`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faChartArea} />
                Q3 2024
              </div>
            </Link>
          </MenuItem>
          <MenuItem>
            <Link to={`/${subDomain}/public-players-benchmark-q2-24`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faChartArea} />
                Q2 2024
              </div>
            </Link>
          </MenuItem>
          <MenuItem>
            <Link to={`/${subDomain}/public-players-benchmark-q1-24`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faChartColumn} />
                Q1 2024
              </div>
            </Link>
          </MenuItem>
          <MenuItem>
            <Link to={`/${subDomain}/public-players-benchmark-q4-23`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faChartArea} />
                Q4 2023
              </div>
            </Link>
          </MenuItem>
          <MenuItem>
            <Link to={`/${subDomain}/public-players-benchmark-q3-23`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faChartColumn} />
                Q3 2023
              </div>
            </Link>
          </MenuItem>
          <MenuItem>
            <Link to={`/${subDomain}/public-players-benchmark-fy`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faChartBar} />
                FY 2023
              </div>
            </Link>
          </MenuItem>
          <MenuItem>
            <Link to={`/${subDomain}/guild-expenses`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faChartSimple} />
                Guild Expenses
              </div>
            </Link>
          </MenuItem>
        </SubMenu>
      </SubMenu>
    </>
  );
};

export const grateRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}`,
      element: <Redirect redirectTo={`/${subDomain}/product`} />,
    },
    {
      path: `/${subDomain}/product`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              breakPoint={DefaultSidebarBreakpoint}
              enableFullFeatures={true}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              pageId={Page.Liveboards}
              orgObject={gRateObject}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/forecast-variance`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<ForecastVariance />}
          groups={secureRouteGroups}
        />
      ),
    } /* 
    {
      path: `/${subDomain}/mba-benchmark-q3`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<MBABenchmark period="Q32023" />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/mba-benchmark-q4`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<MBABenchmark period="Q42023" />}
          groups={secureRouteGroups}
        />
      ),
    }, */,
    {
      path: `/${subDomain}/mba-benchmark-q3-2024`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<MBABenchmark period="Q32024" />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/public-players-benchmark-q3-23`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<PublicPlayersBenchmark period="Q3 2023" />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/public-players-benchmark-q4-23`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<PublicPlayersBenchmark period="Q4 2023" />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/public-players-benchmark-q1-24`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<PublicPlayersBenchmark period="Q1 2024" />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/public-players-benchmark-q2-24`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<PublicPlayersBenchmark period="Q2 2024" />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/public-players-benchmark-q3-24`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<PublicPlayersBenchmark period="Q3 2024" />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/public-players-benchmark-fy`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<PublicPlayersBenchmark period="FY" />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/guild-expenses`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<WaterfallPlots />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};
